var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { fullSize: _vm.loading } }, [
    _c(
      "div",
      [
        _c(
          "v-row",
          {
            staticClass: "mt-2 titles",
            staticStyle: {
              position: "absolute",
              top: "4px",
              left: "40px",
              "z-index": "1",
            },
            attrs: { justify: "center" },
          },
          [
            _c(
              "v-icon",
              { staticClass: "mr-2", attrs: { color: "primary", size: "18" } },
              [_vm._v("fas fa-bug")]
            ),
            _c("p", { staticClass: "debug-page-title" }, [_vm._v("Debugger")]),
          ],
          1
        ),
        _c(
          "v-tabs",
          {
            staticClass: "debugger-page-tabs",
            attrs: {
              "background-color": _vm.$vuetify.theme.dark ? "#262B2E" : "#fff",
              centered: "",
              dark: "",
              "icons-and-text": "",
              "hide-slider": "",
              height: "60",
            },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _c(
              "v-tab",
              {
                staticClass: "vTabClass",
                attrs: { "active-class": "selectedTab" },
                on: { click: _vm.applicationTab },
              },
              [_vm._v(" Application "), _c("v-icon", [_vm._v("mdi-phone")])],
              1
            ),
            _c(
              "v-tab",
              {
                staticClass: "vTabClass",
                attrs: { "active-class": "selectedTab" },
                on: { click: _vm.showPGCards },
              },
              [_vm._v(" Price Guard "), _c("v-icon", [_vm._v("mdi-heart")])],
              1
            ),
            _c(
              "v-tab",
              {
                staticClass: "vTabClass",
                attrs: { "active-class": "selectedTab" },
                on: { click: _vm.showPGCards },
              },
              [_vm._v(" Recovery "), _c("v-icon", [_vm._v("mdi-heart")])],
              1
            ),
            _c(
              "v-tabs-items",
              {
                staticClass: "accent",
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  [
                    _vm.loading
                      ? _c("loading-page")
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              overflow: "hidden auto",
                              height: "calc(100vh - 120px) !important",
                            },
                            attrs: { flat: "", color: _vm.backgroundColor },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("v-row", { attrs: { justify: "center" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ml-7 mt-4",
                                      style: _vm.debugCardWidth,
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticStyle: {
                                            display: "-webkit-box",
                                            "-webkit-box-align": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "mb-0 mr-2" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    `Debugger ${
                                                      _vm.debug ? "On" : "Off"
                                                    }`
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("v-switch", {
                                            attrs: { color: "primary" },
                                            on: {
                                              change: _vm.debugStateChange,
                                            },
                                            model: {
                                              value: _vm.debug,
                                              callback: function ($$v) {
                                                _vm.debug = $$v
                                              },
                                              expression: "debug",
                                            },
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "ml-0 mb-1 mr-1 ml-2",
                                              staticStyle: {
                                                "margin-top": "2px",
                                              },
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showMoreettings =
                                                    !_vm.showMoreettings
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.showMoreettings
                                                      ? "primary"
                                                      : "white",
                                                    small: "",
                                                  },
                                                },
                                                [_vm._v(" fas fa-cog ")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.showMoreettings
                                            ? _c("div", [
                                                _vm._v("Interval (s)"),
                                              ])
                                            : _vm._e(),
                                          _vm.showMoreettings
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "ml-2",
                                                  staticStyle: {
                                                    width: "30px",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "interval-field ml-2",
                                                    staticStyle: {
                                                      width: "20px !important",
                                                      "margin-bottom": "-8px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.debugIntervalTime,
                                                      callback: function ($$v) {
                                                        _vm.debugIntervalTime =
                                                          _vm._n($$v)
                                                      },
                                                      expression:
                                                        "debugIntervalTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.showMoreettings
                                            ? _c(
                                                "v-btn",
                                                {
                                                  class: _vm.$vuetify.breakpoint
                                                    .xsOnly
                                                    ? "ml-4"
                                                    : "ml-6",
                                                  attrs: {
                                                    fab: _vm.$vuetify.breakpoint
                                                      .xsOnly,
                                                    color: "primary",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: _vm.setIntervalTime,
                                                  },
                                                },
                                                [_vm._v(" ok ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { justify: "center" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "debug-card pa-3 pl-4",
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-top": "-16px",
                                    },
                                    style: _vm.debugCardWidth,
                                  },
                                  [
                                    _c("v-row", [
                                      _c("div", { staticClass: "ml-2" }, [
                                        _vm._v("Status:"),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-2",
                                          class: `${_vm.statusColor}--text`,
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.debugData.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("p", { staticClass: "mt-2" }, [
                                      _vm._v(
                                        "Messages: " +
                                          _vm._s(_vm.debugData.numOfMessages)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "Exceptions: " +
                                          _vm._s(_vm.debugData.numOfExceptions)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " Last message at: " +
                                          _vm._s(
                                            _vm.debugData.lastMessageTimestamp
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.debugData.lastMessageTimestamp >
                                              0
                                              ? "(" +
                                                  new Date(
                                                    _vm.debugData.lastMessageTimestamp
                                                  ).toLocaleString() +
                                                  ")"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _vm.debugData.totalProcessingTime / 1000 < 1
                                      ? _c("p", [
                                          _vm._v(
                                            " Total Processing time: " +
                                              _vm._s(
                                                _vm.debugData
                                                  .totalProcessingTime + "ms"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("p", [
                                          _vm._v(
                                            " Total Processing time: " +
                                              _vm._s(
                                                _vm.debugData
                                                  .totalProcessingTime /
                                                  1000 >
                                                  60
                                                  ? _vm.calculateTime(
                                                      _vm.debugData
                                                        .totalProcessingTime +
                                                        Date.now()
                                                    )
                                                  : _vm.debugData
                                                      .totalProcessingTime /
                                                      1000 +
                                                      "s"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                    _vm.debugData.averageProcessingTime / 1000 <
                                    1
                                      ? _c("p", [
                                          _vm._v(
                                            " Average Processing time: " +
                                              _vm._s(
                                                _vm.debugData
                                                  .averageProcessingTime + "ms"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("p", [
                                          _vm._v(
                                            " Average Processing time: " +
                                              _vm._s(
                                                _vm.debugData
                                                  .averageProcessingTime /
                                                  1000 >
                                                  60
                                                  ? _vm.calculateTime(
                                                      _vm.debugData
                                                        .averageProcessingTime +
                                                        Date.now()
                                                    )
                                                  : _vm.debugData
                                                      .averageProcessingTime /
                                                      1000 +
                                                      "s"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                    _c("p", [
                                      _vm._v(
                                        "Last Topic Message: " +
                                          _vm._s(_vm.debugData.lastTopicMessage)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        "Last Topic Publisher: " +
                                          _vm._s(_vm.debugData.lastPublisher)
                                      ),
                                    ]),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.$vuetify.breakpoint.xsOnly,
                                          bottom: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "primary--text",
                                                      staticStyle: {
                                                        "font-size":
                                                          "17px !important",
                                                        position: "absolute",
                                                        top: "14px",
                                                        right: "11px",
                                                      },
                                                      on: {
                                                        click: _vm.resetMetrics,
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v("fas fa-redo-alt ")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [_c("span", [_vm._v("Reset Metrics")])]
                                    ),
                                    _c("v-progress-linear", {
                                      staticClass: "loading-animation",
                                      class: { showLenear: _vm.debug },
                                      attrs: {
                                        indeterminate: "",
                                        color: "primary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              { attrs: { justify: "center" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "debug-card pa-3 pl-4 mt-9",
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-top": "-16px",
                                    },
                                    style: _vm.debugCardWidth,
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-5 mt-1",
                                            staticStyle: {
                                              "margin-bottom": "2px",
                                            },
                                            attrs: { small: "" },
                                          },
                                          [_vm._v("far fa-clock ")]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 ml-2 mt-1" },
                                          [_vm._v("Scheduler")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-select", {
                                              staticClass: "pa-2",
                                              attrs: {
                                                "menu-props": { offsetY: true },
                                                items: _vm.executionTypes,
                                                color: _vm.$vuetify.theme.dark
                                                  ? "primary"
                                                  : "secondary",
                                                label: "Execution Type",
                                                "hide-details": "",
                                                dark: "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              model: {
                                                value: _vm.executionType,
                                                callback: function ($$v) {
                                                  _vm.executionType = $$v
                                                },
                                                expression: "executionType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "pa-2",
                                              attrs: {
                                                color: _vm.$vuetify.theme.dark
                                                  ? "primary"
                                                  : "secondary",
                                                "hide-details": "",
                                                label:
                                                  "Scheduler Interval (ms)",
                                                type: "number",
                                                dark: "",
                                                dense: "",
                                                outlined: "",
                                              },
                                              model: {
                                                value: _vm.schedulerInterval,
                                                callback: function ($$v) {
                                                  _vm.schedulerInterval =
                                                    _vm._n($$v)
                                                },
                                                expression: "schedulerInterval",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c("v-spacer"),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: { click: _vm.updateScheduler },
                                          },
                                          [_vm._v("Save")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  [
                    _c(
                      "v-row",
                      { staticClass: "mx-0" },
                      [
                        _c(
                          "div",
                          { staticStyle: { "max-width": "280px" } },
                          [
                            _c("v-select", {
                              staticClass: "mx-4 mt-3 mb-2 pl-2 pt-2",
                              attrs: {
                                disabled: _vm.loadingPGStatistics,
                                items: _vm.PGServers,
                                "menu-props": {
                                  offsetY: true,
                                  maxHeight: "250",
                                },
                                label: "Select server",
                                dense: "",
                                "hide-details": "",
                              },
                              on: { change: _vm.PGServerChanged },
                              scopedSlots: _vm._u([
                                {
                                  key: "item",
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mb-0 char-lim-tabs dense-select-item",
                                        },
                                        [_c("div", [_vm._v(_vm._s(item))])]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.PGServerSelected,
                                callback: function ($$v) {
                                  _vm.PGServerSelected = $$v
                                },
                                expression: "PGServerSelected",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "max-width": "250px" } },
                          [
                            _c("v-text-field", {
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                disabled: _vm.loadingPGStatistics,
                                rules: _vm.regexSearch
                                  ? [_vm.rules.validRegex]
                                  : [],
                                dark: "",
                                dense: "",
                                color: _vm.$vuetify.theme.dark
                                  ? "primary"
                                  : "secondary",
                                "append-icon": "search",
                                placeholder: _vm.regexSearch
                                  ? "Search with regex"
                                  : "Search",
                                "single-line": "",
                                hint: "Press enter to search",
                              },
                              on: { keydown: _vm.filterCards },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mb-2",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.switchRegex.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              key: _vm.regexBtnRenderKey,
                                              staticClass: "absolute",
                                              class: _vm.regexSearch
                                                ? "primary--text"
                                                : "white--text",
                                              staticStyle: {
                                                left: "12px",
                                                "font-size": "17px",
                                              },
                                            },
                                            [_vm._v(" * ")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "absolute",
                                              class: _vm.regexSearch
                                                ? "primary--text"
                                                : "white--text",
                                              staticStyle: {
                                                left: "5px",
                                                "font-size": "25px",
                                                "margin-bottom": "2px",
                                              },
                                            },
                                            [_vm._v(" . ")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-2",
                                          attrs: { icon: "", "x-small": "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.showSearchBy =
                                                !_vm.showSearchBy
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.showSearchBy
                                                  ? "primary"
                                                  : "white",
                                                small: "",
                                              },
                                            },
                                            [_vm._v("fas fa-cog ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.search,
                                callback: function ($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.showSearchBy
                          ? _c(
                              "div",
                              { staticStyle: { "max-width": "200px" } },
                              [
                                _c("v-select", {
                                  staticClass: "mx-4 mt-3 mb-2 pl-2 pt-2",
                                  attrs: {
                                    disabled: _vm.loadingPGStatistics,
                                    items: _vm.searchByItems,
                                    "menu-props": {
                                      offsetY: true,
                                      maxHeight: "250",
                                    },
                                    label: `Search ${_vm.searchBy}`,
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-0 char-lim-tabs dense-select-item",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(_vm._s(item)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    389882379
                                  ),
                                  model: {
                                    value: _vm.searchBy,
                                    callback: function ($$v) {
                                      _vm.searchBy = $$v
                                    },
                                    expression: "searchBy",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("v-spacer"),
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              disabled: _vm.$vuetify.breakpoint.xsOnly,
                              bottom: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "primary reset-btn mt-3 mr-6",
                                          attrs: {
                                            disabled: _vm.loadingPGStatistics,
                                            rounded: "",
                                            icon: "",
                                            text: "",
                                            width: "28",
                                            height: "28",
                                          },
                                          on: {
                                            click: _vm.refreshPGStatistics,
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                            },
                                          },
                                          [_vm._v("fas fa-redo-alt")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c("span", [
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v("Refresh"),
                              ]),
                              _vm.lastRefresh && !_vm.loadingPGStatistics
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "mb-0 mt-1 mr-2",
                                      staticStyle: { "font-size": "14px" },
                                    },
                                    [
                                      _vm._v(
                                        " Last refresh : " +
                                          _vm._s(_vm.lastRefresh) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "overflow-y": "auto",
                          "overflow-x": "hidden",
                        },
                        attrs: { id: "pg-cards-wrapper" },
                      },
                      [
                        _vm.loadingPGStatistics
                          ? _c("loading-page")
                          : _vm.showNoDataText
                          ? _c(
                              "v-row",
                              {
                                staticClass: "mx-1",
                                staticStyle: { height: "100%" },
                                attrs: { justify: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticStyle: { height: "100%" },
                                        attrs: {
                                          align: "center",
                                          justify: "center",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.noDataText) + " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "v-row",
                              {
                                staticClass: "mx-1",
                                attrs: { id: "cardsContainer" },
                              },
                              _vm._l(_vm.PGCards, function (card) {
                                return _c(
                                  "v-col",
                                  {
                                    key: card.key,
                                    staticStyle: {
                                      "padding-left": "8px",
                                      "padding-right": "8px",
                                    },
                                    attrs: {
                                      lg: "3",
                                      md: "4",
                                      sm: "6",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-lazy",
                                      {
                                        attrs: {
                                          options: {
                                            threshold: 0.1,
                                          },
                                          "min-height": "200",
                                          transition: "fade-transition",
                                          value: false,
                                        },
                                      },
                                      [
                                        _c("priceguard-statistics-card", {
                                          attrs: { card: card },
                                          on: {
                                            "show-more": function ($event) {
                                              card.showMore = true
                                            },
                                            "show-less": function ($event) {
                                              card.showMore = false
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  [
                    _c(
                      "v-row",
                      { staticClass: "mx-0", attrs: { justify: "center" } },
                      [_c("Recovery")],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }